// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SummaryCartItemPrice-module-price-kQUJG{text-align:end;color:#373a36;font-size:16px;font-weight:var(--weight-medium);letter-spacing:1.5px;line-height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"price": "SummaryCartItemPrice-module-price-kQUJG"
};
export default ___CSS_LOADER_EXPORT___;
